/* unplugin-vue-components disabled */import script from "./DramaPerformance.vue?vue&type=script&setup=true&lang=js"
export * from "./DramaPerformance.vue?vue&type=script&setup=true&lang=js"

import "./DramaPerformance.vue?vue&type=style&index=0&id=3ce6326d&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce6326d"]])

export default __exports__